import React, { useState, useRef } from "react";
import { Microphone, Send, Trash, PlayerPlay, PlayerPause, Loader } from "tabler-icons-react";
import MicRecorder from "mic-recorder-to-mp3";
import recordingGif from "assets/audios/recording.gif";
import youngGirl from "../../../assets/images/young_girl.png";
import Modal from "components/modal";
import { toast } from "sonner";


const WordRecordingButton = ({
    onTranscription,
    targetWord,
    onReset,
    disabled = false,
    currentIndex,
    totalCount,
    valid,
    onClickButton,
    isRequesting,
    ButtonDisabled = false,
}) => {
    const [isRecording, setIsRecording] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [isReader, setIsReader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [audio, setAudio] = useState(null);
    const [recorder] = useState(new MicRecorder({ bitRate: 128 }));
    const [micPermissionDenied, setMicPermissionDenied] = useState(false);
    const [showPermissionModal, setShowPermissionModal] = useState(false);
    // const [retryCount, setRetryCount] = useState(0);
    const audioRef = useRef();

    const isRecordingSupported = () => {
        return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
    };

    const spliterSentences = (text = "") => {
        let newText = [];
        if (text?.includes("-")) {
            newText = text?.split("-");
        } else {
            newText = [text];
        }

        return newText;
    };
    const unlockAudioContext = () => {
        if (window.audioContext && window.audioContext.state === "suspended") {
            const silentBuffer = window.audioContext.createBuffer(1, 1, 22050);
            const source = window.audioContext.createBufferSource();
            source.buffer = silentBuffer;
            source.connect(window.audioContext.destination);
            source.start();
        }
    };

    const checkMicrophonePermission = async () => {
        try {
            // Vérifier si l'API Permissions est disponible
            if (navigator.permissions && navigator.permissions.query) {
                const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
                return permissionStatus.state; // 'granted', 'denied', 'prompt'
            }
            return 'prompt'; // Par défaut, on suppose qu'on peut demander
        } catch (error) {
            console.log("Permissions API not supported, will try direct access");
            return 'prompt';
        }
    };

    // const requestMicrophoneAccess = async () => {
    //     try {
    //         // Demander l'accès au microphone
    //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //         // Arrêter immédiatement le stream pour libérer le micro
    //         stream.getTracks().forEach(track => track.stop());
    //         return true;
    //     } catch (error) {
    //         console.error("Microphone access denied:", error);
    //         return false;
    //     }
    // };

    const startRecording = async () => {
        // Vérifier d'abord l'état de la permission
        const permissionState = await checkMicrophonePermission();
        
        if (permissionState === 'denied') {
            setMicPermissionDenied(true);
            setShowPermissionModal(true);
            return;
        }

        // Tenter de démarrer l'enregistrement
        if (!window.audioContext) {
            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            window.audioContext = new window.AudioContext();
        }
        unlockAudioContext();

        try {
            await recorder.start();
            setIsRecording(true);
            setIsPaused(false);
            setMicPermissionDenied(false);
            setShowPermissionModal(false);
        } catch (error) {
            console.error("Error starting recording:", error);
            
            // Vérifier si c'est une erreur de permission
            if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                setMicPermissionDenied(true);
                setShowPermissionModal(true);
            } else {
                // Autre type d'erreur
                alert("Erreur lors du démarrage de l'enregistrement. Veuillez réessayer.");
            }
        }
    };

    // const handleRetryPermission = async () => {
    //     setShowPermissionModal(false);
    //     setIsLoading(true);
    //     setRetryCount(prev => prev + 1);
        
    //     // Attendre un peu avant de redemander
    //     setTimeout(async () => {
    //         try {
    //             // Forcer une nouvelle demande d'autorisation
    //             const stream = await navigator.mediaDevices.getUserMedia({ 
    //                 audio: true 
    //             });
                
    //             // Si on arrive ici, l'autorisation est accordée
    //             stream.getTracks().forEach(track => track.stop());
    //             setMicPermissionDenied(false);
    //             setRetryCount(0);
    //             setIsLoading(false);
                
    //             // Démarrer automatiquement l'enregistrement
    //             startRecording();
    //         } catch (error) {
    //             setIsLoading(false);
    //             console.error("Permission denied again:", error);
                
    //             // Si l'utilisateur refuse encore ou si c'est bloqué
    //             if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
    //                 setMicPermissionDenied(true);
                    
    //                 // Afficher un message plus explicite si bloqué définitivement
    //                 setTimeout(() => {
    //                     setShowPermissionModal(true);
    //                 }, 500);
    //             }
    //         }
    //     }, 300);
    // };

    const stopRecording = (stop = false) => {
        recorder
            .stop()
            .getMp3()
            .then(([buffer, blob]) => {
                const file = new File(buffer, "audio.mp3", {
                    type: blob.type,
                    lastModified: Date.now(),
                });
                addAudioElement(file, stop);
                const audioURL = URL.createObjectURL(file);
                setAudio(audioURL);
                setIsRecording(false);
            })
            .catch((e) => {
                console.error("Error stopping recording:", e);
                // Enregistrement trop court ("No buffer to send") ou autre échec :
                // sans ce reset, l'UI reste bloquée sur les contrôles d'enregistrement
                // et le mot ne peut plus jamais être validé.
                setIsRecording(false);
                setIsReader(false);
                setIsPaused(false);
                setAudio(null);
                toast.error(
                    "L'enregistrement était trop court. Réessayez en parlant un peu plus longtemps."
                );
            });
    };

    const cancelRecording = () => {
        recorder.stop();
        setIsRecording(false);
        setIsPaused(false);
        setAudio(null);
    };

    const addAudioElement = async (file, stop) => {
        if (!file) return;

        // Simplement retourner l'audio au parent sans faire l'envoi automatique
        // L'envoi se fera une seule fois à la fin quand tous les mots sont transcrits
        onTranscription(null, file); // Pas de transcription immédiate, juste l'audio
    };

    const handleReset = () => {
        setIsRecording(false);
        setIsPaused(false);
        setIsReader(false);
        setAudio(null);
        if (onReset) {
            onReset();
        }
    };

    return (
        <div className={`${isRecording ? "pb-32" : "pb-0"} grid place-items-center relative min-h-[400px]`}>
            {/* Modal de permission du microphone */}
            <Modal opened={showPermissionModal} onClosed={() => setShowPermissionModal(false)}>
                <div className="text-center mb-4 mt-6">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Microphone size={32} color="#ef4444" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Autorisation du microphone requise
                    </h3>
                    <p className="text-gray-600 mb-4">
                        Pour enregistrer votre voix, vous devez autoriser l'accès au microphone.
                    </p>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                    <p className="text-sm text-blue-800 font-medium mb-3">
                        📱 Comment autoriser le microphone :
                    </p>
                    <ol className="text-sm text-blue-700 space-y-2 list-decimal list-inside">
                        <li>Fermez ce message en cliquant sur "Quitter"</li>
                        <li>Cliquez à nouveau sur le bouton microphone</li>
                        <li>Autorisez l'accès au microphone dans la popup du navigateur</li>
                    </ol>
                    <div className="mt-3 pt-3 border-t border-blue-200">
                        <p className="text-xs text-blue-600">
                            💡 <strong>Note :</strong> Si la popup n'apparaît pas, vous devez débloquer manuellement dans les paramètres de votre navigateur
                        </p>
                    </div>
                </div>

                <div className="flex flex-col gap-3">
                    <button
                        onClick={() => setShowPermissionModal(false)}
                        className="w-full px-4 py-4 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 transition-colors text-lg"
                    >
                        Quitter
                    </button>
                </div>
            </Modal>

            <div className="flex w-full items-center gap-4 mt-2 mb-24">
                <h3 className="self-center w-32 text-base fw-bold bg-gray rounded-full px-4 py-1">Mot {currentIndex + 1} / {totalCount}</h3>
                <div className="w-full bg-gray h-2 rounded-full overflow-hidden">
                    <div
                        className="bg-primary h-full transition-all duration-500"
                        style={{ width: `${((currentIndex + 1) / totalCount) * 100}%` }}
                    />
                </div>
            </div>
            <div className="flex w-full gap-6 items-start mb-8">
                <img src={youngGirl} alt="young_girl" className="h-48 " />
                <div className="flex flex-col gap-2">
                    <div
                        className={`text-balance speech-bubble px-4 py-2 border border-[#9992] bg-[#9991] text-left h-fit ${spliterSentences(targetWord)?.join(" ")
                            .length > 2
                            ? "text-md"
                            : "text-[1.8rem]"
                            } font-bold`}
                    >
                        {targetWord}
                    </div>
                </div>
            </div>
            {isRecording || isReader ? (
                <div className="p-1 absolute bottom-0 left-0 right-0 flex flex-col gap-3 py-2 text-[white]">
                    <div className="flex items-center gap-2 p-2">
                        <div className="flex-1 flex justify-center">
                            {isReader ? (
                                <div className="scale-90">
                                    <audio src={audio} controls ref={audioRef} />
                                </div>
                            ) : (
                                <img src={recordingGif} alt="recording" className="h-24" />
                            )}
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            className="p-2 text-danger"
                            onClick={() => {
                                setIsReader(false);
                                cancelRecording();
                            }}
                            disabled={isLoading}
                        >
                            <Trash />
                        </button>
                        <button
                            className="p-2 bg-primary rounded-full"
                            onClick={() => {
                                setIsReader(true);
                                setIsPaused(true);
                                stopRecording(true);
                            }}
                            disabled={isLoading}
                        >
                            {isReader ? null : isPaused ? <PlayerPlay /> : <PlayerPause />}
                        </button>
                        <button
                            className="bg-[green] p-3 text-[white] rounded-full"
                            onClick={() => {
                                if (isPaused) {
                                    setIsRecording(false);
                                    setIsReader(false);
                                    setIsPaused(false);
                                    setAudio(null);
                                } else {
                                    stopRecording(false);
                                }
                            }}
                            disabled={isLoading}
                        >
                            {isLoading ? <Loader className="animate-spin" /> : <Send />}
                        </button>
                    </div>
                </div>
            ) : (
                <div className="flex items-center justify-center gap-4 p-1 mt-4">
                    {isLoading ? (
                        <div className="p-3">
                            <Loader className="animate-spin" />
                        </div>
                    ) : isRecordingSupported() ? (
                        <div className="flex flex-col items-center gap-3">
                            <button
                                className={`bg-primary rounded-full p-8 shadow-xl ring-4 ring-blue-200 animate-pulse text-white cursor-pointer disabled:opacity-70 ${valid ? "hidden" : ""}`}
                                onClick={startRecording}
                                disabled={isLoading || disabled}
                            >
                                <Microphone
                                    color={isRecording ? "red" : "#fff"}
                                />
                            </button>
                            {micPermissionDenied && (
                                <div className="bg-red-50 border-2 border-red-200 rounded-lg p-3 max-w-sm">
                                    <p className="text-red-700 text-sm text-center font-medium">
                                        ⚠️ Microphone bloqué. Cliquez à nouveau pour autoriser.
                                    </p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <p>L'enregistrement audio n'est pas supporté sur cet appareil.</p>
                    )}
                </div>
            )}
            <div className="p-4 w-full">
                {valid && (
                    <button
                        onClick={onClickButton}
                        disabled={ButtonDisabled || isRequesting}
                        className="w-full bg-primary hover:bg-primary-dark text-white py-3 px-4 rounded-lg font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isRequesting ? "Chargement en cours...." : "Valider"}
                    </button>
                )}
            </div>
        </div>
    );
};

export default WordRecordingButton; 